module.exports = __webpack_public_path__ + "img/smb.e4acfc46.jpg";